import { Component } from '@angular/core';
import { PROCESS_STEPS } from '../../data/landing-content';

@Component({
  selector: 'landing-inversores-process',
  templateUrl: './landing-process.component.html',
  styleUrls: ['./landing-process.component.scss'],
})
export class LandingProcessComponent {
  readonly steps = PROCESS_STEPS;
}
